import { useMemo } from 'react';
import { iconBaseClass, resolveSize } from './SuperIcon.styles';
import type { SuperIconProps } from './SuperIcon.types';

export interface SuperIconViewModel {
  pixelSize: number;
  className: string;
  stroke: number;
  ariaProps: { 'aria-hidden': true } | { role: 'img'; 'aria-label': string };
}

export function useSuperIcon(props: SuperIconProps): SuperIconViewModel {
  const { size, className, accessibilityLabel, strokeWidth } = props;
  return useMemo<SuperIconViewModel>(
    () => ({
      pixelSize: resolveSize(size),
      className: iconBaseClass(className),
      stroke: strokeWidth ?? 1.6,
      ariaProps: accessibilityLabel
        ? { role: 'img', 'aria-label': accessibilityLabel }
        : { 'aria-hidden': true },
    }),
    [size, className, accessibilityLabel, strokeWidth],
  );
}
